import { lazy } from 'react';

// ----------------------------------------------------------------------

const ReportsPage = lazy(() => import('../pages/Reports.page'));
const Member = lazy(() => import('../pages/member/Member'));
const PackagesAndProducts = lazy(() => import('../pages/packages-and-products/PackagesAndProducts'));
const BranchesAndEmployees = lazy(() => import('../pages/branches-and-employees/BranchesAndEmployees'));
const Marketing = lazy(() => import('../pages/marketing/Marketing'));

// ----------------------------------------------------------------------

const ReportsRoutes = [
    {
        path: '/reports',
        element: <ReportsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/member',
        element: <Member />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/packages-and-products',
        element: <PackagesAndProducts />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/branches-and-employees',
        element: <BranchesAndEmployees />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/marketing',
        element: <Marketing />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ReportsRoutes };
